export const toSeconds = (val) => {
  if (Number.isFinite(val)) return val;
  if (typeof val === 'string') {
    const numeric = parseFloat(val.replace('s', ''));
    return Number.isFinite(numeric) ? numeric : null;
  }
  return null;
};

export const formatDuration = (seconds) => {
  if (!Number.isFinite(seconds) || seconds <= 0) return 'Not computed';
  if (seconds < 90) return `${Math.round(seconds)}s`;
  const minutes = Math.round(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (!hours) return `${mins}m`;
  return mins ? `${hours}h ${mins}m` : `${hours}h`;
};

export const formatDistance = (meters) => {
  if (!Number.isFinite(meters) || meters <= 0) return 'Not computed';
  const miles = meters * 0.000621371;
  if (miles < 0.1) return `${miles.toFixed(2)} mi`;
  if (miles < 10) return `${miles.toFixed(2)} mi`;
  return `${miles.toFixed(1)} mi`;
};
